<template>
  <div class="components-forum-feed-new-topic">
    <button class="btn btn-block btn-success" @click="$emit('showModal')">
      <h5 class="mb-0">
        CRIAR TÓPICO
      </h5>
    </button>
    <div class="d-flex flex-column py-4">
      <h5>Top membros</h5>
      <loading :show="isLoadingBestUsers"></loading>
      <div v-for="user in bestUsers" :key="user.id">
        <div class="d-flex justify-content-between align-items-center py-2">
          <div class="d-flex align-items-center">
            <img
              v-if="user.image_profile"
              :src="user.image_profile"
              :alt="user.name"
              class="img-profile"
            />
            <img
              v-else
              src="@/assets/images/forum/sem-imagem-avatar.png"
              :alt="user.name"
              class="img-profile"
            />
            <p class="mx-3 mb-0">{{ user.name }}</p>
          </div>
          <p class="number-coments m-0">
            {{ user.points }}
          </p>
        </div>
      </div>
    </div>
    <h5>Tags Populares</h5>
    <loading :show="isLoadingTags"></loading>
    <div class="d-flex flex-wrap">
      <div v-for="(tag, i) in tags" :key="`tag-${i}`">
        <button
          class="tag d-flex justify-content-center align-items-center"
          @click="onSelectTag(tag)"
        >
          <p class="mb-0 px-3">{{ tag }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NewTopic",
  computed: mapState("forum", ["tags", "bestUsers"]),
  data() {
    return {
      isLoadingBestUsers: true,
      isLoadingTags: true
    };
  },
  methods: {
    onSelectTag(tag) {
      this.$emit("select-tag", tag);
    }
  },
  mounted() {
    this.$store
      .dispatch("forum/getBestUsers")
      .then()
      .finally(() => {
        this.isLoadingBestUsers = false;
      });
    this.$store
      .dispatch("forum/getTags")
      .then()
      .finally(() => {
        this.isLoadingTags = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.components-forum-feed-new-topic {
  .number-coments {
    color: #8b8b8b;
  }

  .img-profile {
    border-radius: 50%;
    width: 32px;
    height: 32px;
  }

  .tag {
    background: #111112;
    height: 33px;
    border-radius: 8px;
    margin: 10px;
    border: none;
    color: #ffffff;
    transition: 0.4s;

    &:hover {
      filter: brightness(80%);
    }
  }

  .btn-success {
    transition: 0.4s;
    &:hover {
      filter: brightness(90%);
    }
  }
}
</style>
